module.exports = __webpack_public_path__ + "static/media/restock_32_blue.a7531b29.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/restock_32_blue.svg
// module id = 1107
// module chunks = 0